module.exports = __webpack_public_path__ + "img/入会打榜@2x.55f5cad1.png";